import { HeadAgreementStatusCodeChip } from "@/components/chips/HeadAgreementStatusCodeChip";
import { formatDateStringRangeWithLocalTimeZone } from "@/lib/dates/formatters";
import { Space } from "@stenajs-webui/core";
import { CardBody } from "@stenajs-webui/elements";
import { InfoBoxItem } from "../../InfoBoxItem";
import { HeadAgreementBox } from "../../types";
import { testIdConstants } from "@/types/test-id-constants/testIdConstants";

interface Props {
  headAgreement: HeadAgreementBox;
}

export const HeadAgreementInfoCardBody: React.FC<Props> = ({
  headAgreement,
}) => {
  const headNameUpperCase = headAgreement.name?.toUpperCase() || "";

  return (
    <CardBody
      flexDirection={"row"}
      flexWrap={"wrap"}
      variant={"compact"}
      data-testid={testIdConstants.headerAgreementHAInfoBox}
    >
      <HeadAgreementStatusCodeChip
        statusCode={headAgreement.statusCode}
        size={"small"}
        key={"head-agreement-infobox-key-0"}
      />
      <Space />
      <InfoBoxItem
        leftContent={"Name"}
        rightContent={headNameUpperCase}
        key={"head-agreement-infobox-key-1"}
      />
      <InfoBoxItem
        leftContent={"Validity"}
        rightContent={formatDateStringRangeWithLocalTimeZone({
          dateStringFrom: headAgreement.valid.start?.isoString,
          dateStringTo: headAgreement.valid.end?.isoString,
        })}
        key={"head-agreement-infobox-key-2"}
      />
      <InfoBoxItem
        leftContent={"No."}
        rightContent={headAgreement.headAgreementNumber}
        key={"head-agreement-infobox-key-3"}
      />
    </CardBody>
  );
};
